/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { Drawer, Card, Form, Row, Col, Select, Checkbox } from 'antd';
import ActionButtonsBar from '@ui/ActionButtonsBar'
import '../CreateAmenity/styles.scss'
import { getGuestrooms } from '../Amenities/helpers'
import { validateFormHelper } from '../Amenities/helpers'
import redirectImg from 'Styles/assets/redirect.png'
import Loading from '../../../../components/Loading'
import { deleteAmenitieForAllGuestRooms } from '../Amenities/helpers'

interface editAmenityProps {
  deleteData: { amenityType: string },
  onClose: () => void,
  visible: boolean,
  setOperation: (a: string) => void,
  setCurrentRow: (a: []) => void,
  setDefKey: (a: string) => void,
  setSingleAmenity: (a: any) => void,
  reload: () => void
}

const DeleteAmenitie = (props: editAmenityProps) => {
  const [form] = Form.useForm()
  const [requiredFlag] = useState(true)
  const [typeOptionsValues, setTypesOptionsValues] = useState([])
  const [ready, setReady] = useState(false)
  const [data, setData] = useState([])
  const [disableFlag, setDisableFlag] = useState<boolean>(false)
  const [amenityName, setAmenityName] = useState<string>('')

  const miscOptions = ['Amenity', 'Accessibility', 'Security']
  const Option = Select.Option


  const changeAmenityName = async (name: string) => {
    setReady(false)
    setAmenityName(name)
    data.map(({ amenities } : { amenities : []}, index) => {
      // @ts-expect-error
      data[index].checked = false
      // @ts-expect-error
      data[index].initial = false
      return amenities.map((amenitie : { type: string }) => {
        if (name.toLocaleLowerCase() === amenitie.type.toLocaleLowerCase()) {
          // @ts-expect-error
          data[index].checked = true
          // @ts-expect-error
          data[index].initial = true
        }
        return setData(data)
      })
    })

    setTimeout(() => setReady(true))
  }

  const onSelectAll = () => {
    setReady(false)
    data.map(({ amenities } : { amenities : []}, index) => {
      // @ts-expect-error
      return data[index].checked = true
    })
    validateForm()
    setTimeout(() => setReady(true))
  }

  const onSingleSelection = useCallback((e: any, idx: number) => {
    e.preventDefault()
    setReady(false)
    // @ts-expect-error
    data[idx].checked = e.target.checked

    setTimeout(() => setReady(true))
  }, [data])

  const onSave = async () => {
    const dataToDelete = data.filter((dt : { checked : boolean }) => dt.checked)
    const idsToDelete: number[] | any = dataToDelete.map(({ grid }) => grid)
    await deleteAmenitieForAllGuestRooms(idsToDelete, props.deleteData.amenityType)
    props.onClose()
    form.resetFields()  
    setTypesOptionsValues([])
    setDisableFlag(true)
    setReady(false)
    props.reload()
  }

  const getGuestRoomsData = useCallback(async () => {
    const { property: { guestrooms: { guestroom }}} = await getGuestrooms()
    setData(guestroom)
  }, [])

  useEffect(() => {
    changeAmenityName(props.deleteData.amenityType)
  }, [data])

  const RoomTypes = useMemo(() => {
    return ready && data.map(({ name, id, checked, initial }, idx) => (
      <Col span={8} style={{ marginBottom: 24 }}>
        <Checkbox key={idx} onChange={(e: any) => {onSingleSelection(e, idx); validateForm();}} defaultChecked={checked}>
          <div style={{ position: 'absolute', top: -6, pointerEvents: 'none'}}>
            <span style={{ color: '#2D2D2D' }}>{name}</span>
            <br/>
            <span style={{ color: '#8E8E8E' }}>{id}</span>
          </div>
        </Checkbox>
        <img
          onClick={() => {
            props.setOperation('view')
            props.setCurrentRow(data[idx])
            props.setDefKey('7')
            props.setSingleAmenity(amenityName)
          }}
          src={redirectImg}
          alt='redirect to amenities'
          style={{
            marginLeft: 16,
            zIndex: 20,
            position: 'relative',
            top: -8,
            left: 46,
            cursor: 'pointer',
            display: checked && initial ? 'block' : 'none'
          }}/>
      </Col>
    ))
  }, [amenityName, data, onSingleSelection, props, ready])

  // validating the required values have been fufilled properly
  const validateForm = useCallback(() => {
    const selected: any[] = data.filter(({ checked }) => checked)
    if (data.length > 0 && selected.length > 0) {
      return validateFormHelper(form, setDisableFlag)
    } else {
      setDisableFlag(true)
    }
  }, [data, form])

  useEffect(() => {
    props.visible && getGuestRoomsData()
    if (!props.visible) {
      form.resetFields()  
      setTypesOptionsValues([])
      setDisableFlag(true)
      setReady(false)
    } else {
      setDisableFlag(false)
    }
  }, [form, getGuestRoomsData, props])


  return (
    <Drawer
      title="Delete Amenity" 
      placement="right" 
      onClose={props.onClose} 
      visible={props.visible} 
      width={976} 
      afterVisibleChange={() => {
        form.setFieldsValue({ amenity: props.deleteData.amenityType }); 
      }}>
      <Card style={{ marginTop: -15, marginBottom: 65 }}> 
        <Form
          layout='vertical'
          form={form}
          name='basic'
          initialValues={{
            categorytype: 'Amenity'
          }}
          onValuesChange={validateForm}
          >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                label='Amenity / Accessibility / Security'
                name='categorytype'
                rules={[
                  {
                    required: requiredFlag,
                    message: 'This field is required',
                  },
                ]}>
                <Select allowClear showSearch placeholder='Please select' disabled={true}>
                  {miscOptions.map((item: string, i: number) => (
                    <Option key={`${item}-${i}`} value={item}>
                      {item}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label='Amenity'
                name='amenity'
                rules={[
                  {
                    required: requiredFlag,
                    message: 'This field is required',
                  },
                ]}>
                <Select allowClear showSearch disabled={true}>
                {typeOptionsValues.map(
                  (item: { codeName: string }, i: number) => (
                    <Option key={`${item.codeName}-${i}`} value={item.codeName}>
                      {item.codeName}
                    </Option>
                  ),
                )}
              </Select>
              </Form.Item>
            </Col>
          </Row>
          <br />
          <Row gutter={24}>
            {ready && 
            <Col span={24} style={{ marginBottom: 26 }}>
              <span style={{ color: '#999999' }}> Room included </span>
              <b style={{ color: '#06789D', cursor: 'pointer', marginLeft: 16}} onClick={onSelectAll}>Select All</b>
            </Col>}
            {!ready && <div style={{ marginTop: '25%' }}> <Loading type={'large'} /> </div>}
            { ready && RoomTypes }
          </Row>
        </Form>
        <ActionButtonsBar
          onCancel={props.onClose}
          onSave={onSave}
          disabledSave={disableFlag}
          show={true}
        />
      </Card>
    </Drawer>
  )
}

export default DeleteAmenitie
